import { useEffect, useState } from 'react';
import AddMediaIcon from '../../../assets/icon/add-media.png';
import EditorComponent from 'components/Editor';
import './AddWebPagesForm.css';
import { Button, Input, Upload } from 'antd';
import { imgUrl } from 'utils/url';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { fetchWebLayout } from 'state/actions/webLayout';

const AddSection = ({ onAdd, selectedSection, selectedLayout }) => {
  useEffect(() => {
    if (!selectedSection) return;
    setSectionId(selectedSection.sectionId || '');
    setSectionTitle(selectedSection.sectionTitle || '');

    if (selectedSection.blocks) {
      const normalizedBlocks = selectedSection.blocks.map((b) => ({
        ...b,
        key: b.variable,
        id: b.id || crypto.randomUUID(),
      }));

      setBlocks(JSON.parse(JSON.stringify(normalizedBlocks)));
    }
  }, [selectedSection]);

  const [sectionId, setSectionId] = useState('');
  const [sectionTitle, setSectionTitle] = useState('');
  const [errors, setErrors] = useState({});
  const [blocks, setBlocks] = useState([]);
  const [saveAsTemplate, setSaveAsTemplate] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    let newErrors = {};

    if (!sectionId.trim()) {
      newErrors.sectionId = 'Section ID is required';
    }

    if (!sectionTitle.trim()) {
      newErrors.sectionTitle = 'Section ID is required';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (!selectedSection) {
      newErrors.template = 'Please select a template';
    }

    const customBlocks = selectedLayout?.content
      ?.filter(
        (item) =>
          item.type === 'menus' ||
          item.type === 'tenants' ||
          item.type === 'medias'
      )
      ?.map((item) => {
        let type = '';
        let value = null;

        if (item.menuId) {
          type = 'menus';
          value = item.menuId;
        } else if (item.poiCategoryId) {
          type = 'tenants';
          value = item.poiCategoryId;
        } else if (item.mediaCategoryId) {
          type = 'medias';
          value = item.mediaCategoryId;
        }

        return {
          id: crypto.randomUUID(),
          type,
          variable: item.variable,
          value,
        };
      });
    const newSection = {
      // id: selectedSection?.isFromTemplate
      //   ? Date.now()
      //   : selectedSection?.id || Date.now(),
      id: selectedSection?.id || Date.now(),
      sectionId,
      templateId: selectedSection?.templateLayoutId || null,
      templateLayoutId: selectedLayout?._id,
      blocks: [...blocks, ...customBlocks],
      sectionTitle,
      isFromTemplate: selectedSection?.isFromTemplate || false,
      logo: selectedLayout?.logo,
    };
    if (onAdd) {
      onAdd(newSection, selectedSection);
    }

    // reset form
    setSectionId('');
    setSectionTitle('');
    setErrors({});
  };

  const updateBlock = (type, value, variable) => {
    setBlocks((prev) => {
      const exist = prev.find(
        (b) => b.type === type && b.variable === variable
      );

      if (exist) {
        return prev.map((b) =>
          b.type === type && b.variable === variable ? { ...b, value } : b
        );
      }

      return [...prev, { type, value, variable }];
    });
  };

  const handleMultipleImages = (e, key) => {
    const files = Array.from(e.target.files);

    const mapped = files.map((file) => ({
      id: crypto.randomUUID(),
      type: 'image',
      key,
      file,
      preview: URL.createObjectURL(file),
      variable: key,
    }));

    setBlocks((prev) => {
      const filtered = prev.filter(
        (b) => !(b.type === 'image' && b.key === key)
      );

      return [...filtered, ...mapped];
    });
  };

  const handleRemoveImage = (id, variable) => {
    setBlocks((prev) =>
      prev.filter((b) => !(b.id === id && b.variable === variable))
    );
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        paddingLeft: '12px',
      }}
    >
      <span
        style={{
          fontWeight: '700',
          fontSize: '24px',
        }}
      >
        Add Section
      </span>
      <form className="form-wrapper" onSubmit={handleSubmit}>
        <div>
          <div className="form">
            <label className="form-label">
              Section ID <span className="is-required">*</span>
            </label>
            <Input
              placeholder="Section ID"
              className={`${
                errors && errors.errors && errors.errors.name ? 'has-error' : ''
              }`}
              value={sectionId}
              onChange={(e) => setSectionId(e.target.value)}
              name="name"
            />
            {errors && errors.errors && errors.errors.name && (
              <span className="error-message">{errors.errors.name[0].msg}</span>
            )}
          </div>

          <div className="form">
            <label className="form-label">Section Title</label>
            <Input
              placeholder="Title"
              className={`${
                errors && errors.errors && errors.errors.name ? 'has-error' : ''
              }`}
              value={sectionTitle}
              onChange={(e) => setSectionTitle(e.target.value)}
              name="name"
            />
            {errors && errors.errors && errors.errors.name && (
              <span className="error-message">{errors.errors.name[0].msg}</span>
            )}
          </div>

          {selectedLayout?.content?.map((item, index) => {
            if (item.type === 'title') {
              const block = blocks.find(
                (b) => b.type === 'title' && b.variable === item.variable
              );

              return (
                <div className="form" key={index}>
                  <label className="form-label">{item.variable}</label>
                  <Input
                    value={block?.value || ''}
                    onChange={(e) => {
                      updateBlock('title', e.target.value, item.variable);
                    }}
                  />
                </div>
              );
            }

            if (item.type === 'paragraph') {
              const block = blocks.find(
                (b) => b.type === 'paragraph' && b.variable === item.variable
              );

              return (
                <div className="form" key={index}>
                  <label className="form-label">{item.variable}</label>
                  <EditorComponent
                    value={block?.value || ''}
                    onChange={(val) =>
                      updateBlock('paragraph', val, item.variable)
                    }
                  />
                </div>
              );
            }

            if (item.type === 'image') {
              const imageBlocks = blocks.filter(
                (b) => b.type === 'image' && b.key === item.variable
              );

              return (
                <div className="form" key={index}>
                  <label className="form-label">{item.variable}</label>

                  <input
                    type="file"
                    accept="image/*,video/*"
                    id={item.variable}
                    style={{ display: 'none' }}
                    onChange={(e) => handleMultipleImages(e, item.variable)}
                  />
                  <Button
                    onClick={() =>
                      document.getElementById(item.variable).click()
                    }
                    type="dashed"
                  >
                    + Add Image
                  </Button>

                  <div
                    style={{
                      display: 'flex',
                      gap: 10,
                      marginTop: '8px',
                      flexWrap: 'wrap',
                    }}
                  >
                    {imageBlocks.map((img) => (
                      <div
                        key={img.id}
                        style={{
                          position: 'relative',
                          width: '80px',
                          height: '80px',
                        }}
                      >
                        <img
                          src={
                            img.preview ||
                            (img.value ? `${imgUrl}/media/${img.value}` : '')
                          }
                          style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: '6px',
                            border: '1px solid #ddd',
                          }}
                        />

                        <div
                          onClick={() =>
                            handleRemoveImage(img.id, img.variable)
                          }
                          style={{
                            position: 'absolute',
                            top: '-6px',
                            right: '-6px',
                            width: '18px',
                            height: '18px',
                            background: 'red',
                            color: 'white',
                            borderRadius: '50%',
                            fontSize: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                          }}
                        >
                          ×
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              );
            }

            if (item.type === 'button') {
              const block =
                blocks.find(
                  (b) => b.type === 'button' && b.variable === item.variable
                ) || {};
              return (
                <div key={index}>
                  <div className="form">
                    <label className="form-label">{item.variable}</label>
                    <Input
                      placeholder="Button Text"
                      value={block?.value?.text || ''}
                      onChange={(e) =>
                        updateBlock(
                          'button',
                          {
                            ...block.value,
                            text: e.target.value,
                          },
                          item.variable
                        )
                      }
                    />
                  </div>

                  <div className="form">
                    <label className="form-label">{item.variable} URL</label>
                    <Input
                      placeholder="https://example.com"
                      value={block?.value?.url || ''}
                      onChange={(e) =>
                        updateBlock(
                          'button',
                          {
                            ...block.value,
                            url: e.target.value,
                          },
                          item.variable
                        )
                      }
                    />
                  </div>
                </div>
              );
            }

            return null;
          })}

          <div style={{ marginTop: '16px' }}>
            {!selectedSection?.isFromTemplate && (
              <div style={{ marginTop: '12px', marginBottom: '12px' }}>
                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={saveAsTemplate}
                    onChange={(e) => setSaveAsTemplate(e.target.checked)}
                  />
                  <span className="checkmark"></span>
                  Save as Template
                </label>
              </div>
            )}
            <Button type="primary" htmlType="submit">
              Save Section
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddSection;
